import { render, staticRenderFns } from "./DocumentView3.vue?vue&type=template&id=4cd20ebe&scoped=true"
import script from "./DocumentView3.vue?vue&type=script&lang=js"
export * from "./DocumentView3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd20ebe",
  null
  
)

export default component.exports